/** The rail, and the index's three groups. One list — the index and the rail cannot disagree
 *  about what tools exist. */
export const TOOLS = [
  {
    group: "Find out",
    items: [
      { id: "grader", name: "Trust grader", blurb: "Can this agent be identified at all?" },
      { id: "leaderboard", name: "Leaderboard", blurb: "Who is doing this properly." },
      { id: "directory", name: "Directory", blurb: "A page per host and per agent." },
      { id: "whois", name: "Agent whois", blurb: "Resolve a did to whoever published it." },
      { id: "report", name: "State of Agent Traffic", blurb: "The public report." },
    ],
  },
  {
    group: "Prove it",
    items: [
      { id: "verify", name: "Offline verifier", blurb: "Drop a signed event. No account." },
      { id: "receipt", name: "Verifiable receipt", blurb: "A named human approved this." },
      { id: "badge", name: "Agent-Verified badge", blurb: "Embed a grade you earned." },
      { id: "signin", name: "Sign in with your Agent", blurb: "For relying parties." },
    ],
  },
  {
    group: "Use it",
    items: [
      { id: "observe", name: "Free observability", blurb: "Signed records, no account." },
      { id: "spec", name: "Open specs", blurb: "Seven formats, one vector." },
    ],
  },
] as const;
